import { METERS_PER_LAT_DEG } from "../constants";

/**
 * @name getMetersPerLongitude
 * @description Returns the length of 1° of longitude in meters at the given latitude.
 * | Longitude degrees shrink by cos(latitude) as you move away from the equator.
 *
 * @see https://en.wikipedia.org/wiki/Geographic_coordinate_system#Length_of_a_degree
 */
function getMetersPerLongitude(latitudeDeg: number): number {
	const latitudeRad = (latitudeDeg * Math.PI) / 180;
	return METERS_PER_LAT_DEG * Math.cos(latitudeRad);
}

export { getMetersPerLongitude };
